import moment from 'moment';
import Abstract from './Abstract.js';

export default class RowMilestones extends Abstract {
  constructor(props) {
    super(props);
    this.mileRow = null;
  }

  build() {
    const {
      chart,
      options: { height },
      milestones,
    } = this.props;

    const groupMilestonesByDate = (milestones) => {
      const groupedMilestones = {};

      milestones.forEach((milestone) => {
        const dateAt = new Date(milestone.date_at);
        const dateKey = dateAt.toISOString().split('T')[0];

        if (!groupedMilestones[dateKey]) {
          groupedMilestones[dateKey] = [];
        }

        groupedMilestones[dateKey].push(milestone);
      });

      return Object.entries(groupedMilestones).map(
        ([dateAt, childMilestone]) => ({
          date_at: dateAt,
          childMilestone,
        })
      );
    };

    const groupedMilestones = groupMilestonesByDate(milestones);
    const group = chart
      .selectAll('svg')
      .data(
        groupedMilestones.map((mile) => {
          const startDate = moment(mile.date_at).set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          });

          const endDate = moment(mile.date_at).set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 999,
          });

          return {
            ...mile,
            title: null,
            startDate,
            endDate,
          };
        })
      )
      .enter()
      .append('g')
      .attr('class', 'row-group group-mile');

    this.mileRow = group
      .append('rect')
      .attr('class', 'mile')
      .attr('width', 2)
      .attr('x', (d) => this.getVisibleStartX(d))
      .attr('y', 50)
      .attr('height', height);
  }

  update() {
    this.mileRow
      .transition()
      .duration(this.transitionDuration)
      .attr('x', (d) => this.getVisibleStartX(d));
  }

  getStartX(datum) {
    return this.xScale(datum.startDate);
  }

  getEndX(datum) {
    return this.xScale(datum.endDate);
  }

  getVisibleStartX(datum) {
    return this.getStartX(datum) + (this.getWidth(datum) - 2) / 2;
  }

  getWidth(datum) {
    return this.getEndX(datum) - this.getStartX(datum);
  }
}
